/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDeploymentRequest } from '../models/CreateDeploymentRequest';
import type { DeploymentListResponse } from '../models/DeploymentListResponse';
import type { DeploymentResponse } from '../models/DeploymentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DeploymentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Deployments
     * @returns DeploymentListResponse Successful Response
     * @throws ApiError
     */
    public listDeployments({
        state,
    }: {
        state?: (string | null),
    }): CancelablePromise<DeploymentListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/deployments',
            query: {
                'state': state,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Deployment
     * Record a deployment. **201, and it is not running** — see the module docstring.
     *
     * 201 rather than the 202 `POST /backtests` returns: a deployment *is* the resource, created and
     * readable. A backtest row is a request for work that has not happened.
     * @returns DeploymentResponse Successful Response
     * @throws ApiError
     */
    public createDeployment({
        requestBody,
    }: {
        requestBody: CreateDeploymentRequest,
    }): CancelablePromise<DeploymentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/deployments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Deployment
     * @returns DeploymentResponse Successful Response
     * @throws ApiError
     */
    public getDeployment({
        deploymentId,
    }: {
        deploymentId: number,
    }): CancelablePromise<DeploymentResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/deployments/{deployment_id}',
            path: {
                'deployment_id': deploymentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Deployment
     * 🔴 **Starts the six-week clock.** `starting → running`, stamping `started_at`.
     *
     * A separate call from creation, and a `POST` rather than a `PATCH` of `state`: this is not an
     * edit to a field, it is the event the whole gate is measured from. A client that can `PATCH`
     * arbitrary states can also walk a deployment backwards, and `DEPLOYMENT_TRANSITIONS` exists
     * precisely because that must not be possible.
     *
     * 409 when it is not `starting`, and the detail names the state found — *"already running"* is a
     * fact about the row rather than an error, and the caller decides whether it matters.
     * @returns DeploymentResponse Successful Response
     * @throws ApiError
     */
    public startDeployment({
        deploymentId,
    }: {
        deploymentId: number,
    }): CancelablePromise<DeploymentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/deployments/{deployment_id}/start',
            path: {
                'deployment_id': deploymentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
